export default __webpack_public_path__ + "static/B0104-3c1e481c4a92692e2a751fe92c3821a3.png";